import { render, staticRenderFns } from "./产权报名.vue?vue&type=template&id=6e2dbb06&scoped=true"
import script from "./产权报名.vue?vue&type=script&lang=js"
export * from "./产权报名.vue?vue&type=script&lang=js"
import style0 from "./产权报名.vue?vue&type=style&index=0&id=6e2dbb06&prod&lang=css"
import style1 from "./产权报名.vue?vue&type=style&index=1&id=6e2dbb06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2dbb06",
  null
  
)

export default component.exports